import { BaseValidationResponse } from "../../models/validations/validations.models";
import { SubtaskCorrespondenceEmailModel } from "../vetting/vetting.models";

export interface GetCustomerSubscriptionResponse extends BaseValidationResponse {
    customerSubscription: CustomerSubscriptionModel;
}

export interface GetCustomerUnSubscriptionResponse extends BaseValidationResponse {
    customerSubscriptions: CustomerSubscriptionModel[];
}

export interface SaveCustomerSubscriptionRequest {
    customerId: number;
    productId: number;
    productCode: string;
    subscriptionTypeId: number;
    startDate: Date;
    vesselsCount: number;
    vesselChangesCount: number;
    companiesCount: number;
    companyChangesCount: number;
    includeCompanyData: boolean;
    trialLength?: number;
    subscriptionLength?: number;
    totalPrice?: number;
    doesNotExpire?: boolean;
    emailNotifications?: SubtaskCorrespondenceEmailModel[];
    ruleCollectionId?: number;
    businessUnitId?: number;
}

export interface CustomerSubscriptionModel {
    customerId: number;
    productName: string;
    maxVesselsCount?: number;
    currentVesselsCount?: number;
    maxVesselChangesCount?: number;
    currentVesselChangesCount?: number;
    subscriptionTypeId?: number;
    maxCompaniesCount: number;
    currentCompaniesCount: number;
    maxCompanyChangesCount: number;
    currentCompanyChangesCount: number;
    includeCompanyData: boolean;
    productId: number;
    productCode?: string;
    productDescription?: string;
    productType?: number;
    productUrl?: string;
    status?: string;
    statusId?: number;
    subscriptionDetails?: string;
    docsUrl?: string;
    startDate: Date;
    isExpired: boolean;
    trialLength?: number;
    subscriptionLength?: number;
    trialEndDate?: Date;
    subscriptionEndDate?: Date;
    totalPrice?: number;
    doesNotExpire?: boolean;
    emailNotifications?: SubtaskCorrespondenceEmailModel[];
    ruleCollectionId?: number;
    businessUnitId?: number;
}

export enum SubscriptionTypeEnum {
    Limited = 1,
    Full = 2
}

export const SubscriptionProductCodes = {
    informationServices: 'information-services',
    pscRiskIqInApp: 'psc-riskIQ-inapp',
    pscRiskIq: 'psc-riskIQ',
}

export interface CleanCustomerVesselResponse {
    vesselCount: number;
    vesselChangeCount: number;
}